import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useCheckAssignmentSubmission from '../../../hooks/useCheckAssignmentSubmission';
import { v4 as uuid } from 'uuid';
import { useSubmitAssignmentMarkMutation } from '../../../features/assignment/assignmentApi';

const AssignmentModal = ({control, open, id}) => {

    const [repoLink, setRepoLink] = useState("");

    const {id:student_id, name:student_name} = useSelector(state => state.auth.user);
    const { hasSubmitted, assignmentMark, assignment } = useCheckAssignmentSubmission({id});
    const [submitAssignmentMark, {isSuccess}] = useSubmitAssignmentMarkMutation();

    useEffect(() => {
        if(assignmentMark?.id){
            setRepoLink(assignmentMark.repo_link);
        }else{
          setRepoLink("")
        }
    },[assignmentMark, id])

    const handleSubmit = (e) => {
        e.preventDefault();

       if(assignment.length > 0){
        const data = {
            id: uuid(),
            student_id,
            student_name,
            assignment_id: assignment[0].id,
            title: assignment[0].title,
            createdAt: new Date().toISOString(),
            totalMark: assignment[0].totalMark,
            mark: 0,
            repo_link: repoLink,
            status: "pending"
        }
        submitAssignmentMark(data);
        setRepoLink("")
        control()
       }
    }

    const handleClose = () => {
      control()
    }

    return (
        open && (
          <main className="bg-slate-900 flex flex-col mx-8 p-8 form-modal">
            <h1 className="mb-10 text-center lws-section-title mt-8 text-2xl">
             Submit Assignment
            </h1>
            {hasSubmitted && <h1 className="mb-10 text-center lws-section-title mt-8 text-2xl">
             You have already submitted the assignment
            </h1>}
       
            <div className="max-w-3xl mx-auto mt-8">
              <form className="flex flex-col space-y-6" onSubmit={handleSubmit}>
                <div className="fieldContainer">
                  <label>Repo link</label>
                  <div className="flex border border-cyan rounded-md shadow-sm">
                    <input
                      type="text"
                      required
                      className="bg-secondary w-full h-8 py-2 px-3 rounded-md form-input"
                      placeholder="Repository"
                      value={repoLink}
                      onChange={(e) => setRepoLink(e.target.value)}
                      disabled={hasSubmitted}
                    />
                  </div>
                </div>

                <div className="flex justify-end space-x-4">
                  <button
                    onClick={handleClose}
                    className="cursor-pointer btn bg-red-600 w-fit absolute"
                    style={{ marginRight: "10px" }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    id="lws-submit"
                    className="cursor-pointer btn w-fit"
                    disabled={hasSubmitted}
                  >
                   {(hasSubmitted && assignmentMark?.id) ? `Mark: ${assignmentMark.mark}` : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </main>
        )
      );
};

export default AssignmentModal;